import React from 'react';
import { topicPathList } from './const/Const';
import { TTopicPath, TTopicPathState } from './type/Type';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useStyles } from './style/Style';
import { TAttachableObject } from '../../types/common';
import { useHistory } from 'react-router-dom';
import { BillingAlerts } from './BillingAlerts';
import { FactoringAlerts } from './FactoringAlerts';

interface Props {
  [Key: string]: any;
  patternName: string;
  setErrorMessage: any;
  setOpenError: any;
  patternState?: TTopicPathState;
}

/**
 * パンくずリスト生成
 *
 * @param patternName {patternName: パターン名}
 * @constructor
 */
export const TopicPath: React.FC<Props> = ({
  patternName,
  setOpenError,
  setErrorMessage,
  patternState
}) => {
  // スタイル読み込み
  const classes = useStyles();

  const history: any = useHistory();

  // パターン取得
  const pattern: TTopicPath[] = topicPathList[patternName];

  // urlに対してstateが設定されていたら返す
  const getPatternState = (url: string): TAttachableObject | undefined => {
    if (patternState && patternState[url]) return patternState[url];
    return undefined;
  };

  return (
    <nav className={classes.nav}>
      <ol className={classes.ol}>
        {pattern &&
          pattern.map((data: TTopicPath, i: number) => {
            return (
              <>
                {pattern.length - 1 === i ? (
                  // 最後の要素
                  <li key={i} className={classes.liLast}>
                    {data.url ? (
                      <Link
                        to={{
                          pathname: data.url,
                          state: getPatternState(data.url)
                        }}
                        className={classes.linkLast}
                      >
                        {data.name}
                      </Link>
                    ) : (
                      <>{data.name}</>
                    )}
                  </li>
                ) : (
                  // >付きの要素
                  <>
                    <li key={i} className={classes.li}>
                      {data.url ? (
                        <>
                          {data.url === 'goBack' ? (
                            <a
                              className={classes.link}
                              onClick={() => history.goBack()}
                            >
                              {data.name}
                            </a>
                          ) : (
                            <Link
                              to={{
                                pathname: data.url,
                                state: getPatternState(data.url)
                              }}
                              className={classes.link}
                            >
                              {data.name}
                            </Link>
                          )}
                        </>
                      ) : (
                        <>{data.name}</>
                      )}
                    </li>
                    <li key={i} className={classes.li}>
                      <ArrowForwardIosIcon
                        className={classes.arrowForwardIosIcon}
                      />
                    </li>
                  </>
                )}
              </>
            );
          })}
      </ol>
      <FactoringAlerts
        setOpenError={setOpenError}
        setErrorMessage={setErrorMessage}
      />
      <BillingAlerts
        setOpenError={setOpenError}
        setErrorMessage={setErrorMessage}
      />
    </nav>
  );
};
